import WaveFiles from "./assets/wav/WaveFiles";
const DrumpadList = [
  {
    buttonText: "Q",
    audioDescription: "LowTom",
    audioTrack: WaveFiles.LowTom,
    keycode: 81
  },
  {
    buttonText: "W",
    audioDescription: "BassSlap",
    audioTrack: WaveFiles.BassSlap,
    keycode: 87
  },
  {
    buttonText: "E",
    audioDescription: "BassDrum",
    audioTrack: WaveFiles.BassDrum,
    keycode: 69
  },
  {
    buttonText: "A",
    audioDescription: "BassSynth",
    audioTrack: WaveFiles.BassSynth,
    keycode: 65
  },
  {
    buttonText: "S",
    audioDescription: "Cowbell",
    audioTrack: WaveFiles.Cowbell,
    keycode: 83
  },
  {
    buttonText: "D",
    audioDescription: "HighQ",
    audioTrack: WaveFiles.HighQ,
    keycode: 68
  },
  {
    buttonText: "Z",
    audioDescription: "OpenSurdo",
    audioTrack: WaveFiles.OpenSurdo,
    keycode: 90
  },
  {
    buttonText: "X",
    audioDescription: "PedalHiHat",
    audioTrack: WaveFiles.PedalHiHat,
    keycode: 88
  },
  {
    buttonText: "C",
    audioDescription: "VibraSlap",
    audioTrack: WaveFiles.VibraSlap,
    keycode: 67
  }
];

export default DrumpadList;
